export class AysVirtualClinicAnalysisApi {
  constructor(private readonly _baseUrl: string) {}

  public availableResultSetOperations(): string {
    return `${this._baseUrl}/operating-numbers/result-set-operations/available`;
  }

  public availableGroupBys(): string {
    return `${this._baseUrl}/operating-numbers/group-by/available`;
  }

  public availableVirtualClinicOperatingNumbers(): string {
    return `${this._baseUrl}/operating-numbers/virtual-clinic-operating-numbers/available`;
  }

  public availableFullyInpatientCaseOperatingNumbers(): string {
    return `${this._baseUrl}/operating-numbers/fully-inpatient-case-operating-numbers/available`;
  }

  public groupedOperatingNumbers(): string {
    return `${this._baseUrl}/operating-numbers/calculate/grouped`;
  }

  public export(virtualClinicId: string): string {
    return `${this._baseUrl}/virtual-clinics/${virtualClinicId}/master-exports/`;
  }

  public preCalculations(): string {
    return `${this._baseUrl}/operating-numbers/precalculations`;
  }
}
